export default {
  from: 'De',
  to: 'A',
  enterNameOrNumber: 'Ingresar número o nombre...',
  typeMessage: 'Escribir mensaje...',
  send: 'Enviar',
};
